import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, message, Upload, Image } from "antd";
import { accountDataModel } from "./accountDataModel";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { AppDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { UserTypeEnum } from "@/types/FmsEnums";
import { getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants"
import { accountService, creditFlagDs } from "@/views/account/AccountService";
import { useDetailModel } from "../detailModel";
import { useLockFn } from "ahooks";
import FontIcon from "@/components/YhIcon";
import { UploadOutlined, FileExcelOutlined } from "@ant-design/icons";
import { UploadChangeParam } from "antd/lib/upload";
import { getBaseImgLookUrl } from "@/utils/constants";

export const RechargeDrawer = () => {
    const {
        orgDs,
        beDs,
        payMethodDs,
    } = useDetailModel();

    const {
        selectedData,
        rechargeDrawerVisible,
        setRechargeDrawerVisible,
        onReset,
    } = accountDataModel();

    const formRef = useRef<IYhFormRef>();

    const [previewOpen, setPreviewOpen] = useState<boolean>(false);
    const [previewImage, setPreviewImage] = useState<any>();

    useEffect(() => {
        if (rechargeDrawerVisible && selectedData[0]?.creditFlag == 1) {
            let newRecords: any = []
            accountService.getTradeCode(selectedData[0].code ?? "").then(({ retData }) => {
                retData.map((item: any) => {
                    newRecords.push({ label: item.tradeCode, value: item.tradeCode })
                })
                setTradeCodeList(newRecords)
            })
        }
    }, [rechargeDrawerVisible]);

    const normFile = (e: UploadChangeParam) => {
        let filetypes: string[] = [".jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc", ".xls", ".xlsx"];
        let isType: boolean = false;
        let fileEnd: string = e?.file.name.substring(e?.file.name.lastIndexOf("."));
        isType = filetypes?.includes(fileEnd) ?? false;
        console.log('Upload event:', e);
        if (e?.file.status === 'done') {
            if (e?.file.response.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e.file.response.retData,
                    url: getBaseImgLookUrl(e.file.response.retData),
                }
                // e.fileList = [data]
                e.fileList[e.fileList.length - 1] = data
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e;
        }
        if (!isType) {
            e.fileList?.pop()
        }
        return e && e.fileList;
    };
    //实时详情列表货位数据
    const [tradeCodeList, setTradeCodeList] = useState<any>([])


    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        disabled: false,
        formValues: { ...selectedData[0] },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户",
                fieldName: "code",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账户",
                fieldName: "name",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "授信类型",
                fieldName: "creditFlag",
                disable: true,
                span: 24,
                ds: creditFlagDs(),
            },
            {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "机构",
                fieldName: "orgCode",
                disable: true,
                span: 24,
                treeDs: orgDs
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "实体",
                fieldName: "beCode",
                disable: true,
                span: 24,
                ds: beDs
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "剩余金额",
                fieldName: "remainingAmount",
                disable: true,
                span: 24,
            },
            ...(() => {
                if (selectedData[0]?.creditFlag == 1) {
                    return [{
                        type: FormItemTypeEnum.Select,
                        fieldLabel: "关联单号",
                        fieldName: "tradeCodes",
                        span: 24,
                        ds: tradeCodeList,
                        selectMode: "multiple",
                    }]
                } else {
                    return []
                }
            })(),
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "充值金额",
                fieldName: "rechargeAmount",
                span: 24,
                rules: [{
                    required: true,
                    pattern: new RegExp(/^[+|-]?(\d+)$|^[+|-]?(\d+\.\d+)$/),
                    message: "请输入数字!"
                }],
            },
            {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "支付方式",
                fieldName: "payMethodCode",
                span: 24,
                treeData: payMethodDs,
                rules: [{
                    required: true,
                    message: "授信类型不能为空"
                }],
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: "附件",
                fieldName: "file",
                colClassName: "ant-col-h-auto",
                span: 24,
                formItem: <Form.Item
                    name="fileList"
                    label="附件"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                    rules={[
                        {
                            required: true,
                            message: '请上传附件信息'
                        }
                    ]}
                >
                    <Upload
                        name="file"
                        action={getBaseImgUploadUrl()}
                        data={getBaseUploadData()}
                        // headers={{
                        //     authorization: getToken()
                        // }}
                        listType="picture"
                        maxCount={1}
                        // disabled={editModel === 'look'}
                        beforeUpload={(file) => {
                            let fileEnd: string = file.name.substring(file.name.lastIndexOf("."));
                            // let filetypes: string[] = [".jpg", ".png", ".doc", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
                            let filetypes: string[] = [".jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc", ".xls", ".xlsx"];
                            // var filetypes = [".jpg", ".png", ".rar", ".txt", ".zip", ".doc", ".ppt", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
                            let isType = filetypes?.includes(fileEnd);
                            if (!isType) {
                                message.error('不支持该格式的上传,当前仅支持 图片、pdf、xls、xlsx和.doc 类型文件');
                            }
                            const isLt20M = file.size / 1024 / 1024 < 20;
                            if (!isLt20M) {
                                message.error('上传到文件不能超过20M');
                            }
                            return isType && isLt20M;
                        }}

                        iconRender={(file) => {
                            if (file?.type?.indexOf('image/') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-tupian2" />
                            if (file?.type?.indexOf('pdf') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-pdf" />
                            if (file?.type?.indexOf('msword') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-doc" />
                            if (file?.type?.indexOf('sheet') !== -1 || file?.type?.indexOf('excel') !== -1) return <FileExcelOutlined />
                        }}

                        onPreview={(file) => {
                            if (file?.type?.indexOf('pdf') != -1 ||
                                file?.type?.indexOf('msword') != -1 ||
                                file?.type?.indexOf('sheet') !== -1 ||
                                file?.type?.indexOf('excel') !== -1) {
                                window.location.href = file?.url ?? "";
                            }
                            else {
                                setPreviewImage(file?.url);
                                setPreviewOpen(true);
                            }
                        }}
                    >
                        <Button icon={<UploadOutlined />}>选择文件上传</Button>
                    </Upload>
                </Form.Item>
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "收款人",
                fieldName: "operator",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "remark",
                span: 24,
            },
        ]
    };

    const onOk = useLockFn(async () => {
        try {
            let formData = await formRef.current?.validateFields();
            if (formData) {
                const { fileList = [], ...params } = formData
                const reqData = {
                    ...params,
                    accountCode: formData.code,
                    partnerTypeCode: UserTypeEnum.CUSTOMER,
                    partnerCode: selectedData[0].code,
                    note: formData.remark
                };
                if (fileList.length > 0) {
                    const file = fileList[0];
                    if (!file?.uid) {
                        console.log(file);
                        return message.error('文件信息有误，请重新上传文件')
                    }
                    if (file?.status) {
                        console.log(file);
                        return message.warn('文件正在上传，请等待文件上传成功！')
                    }
                    reqData.md5 = file?.uid;
                    reqData.fileName = file.name;
                    reqData.fileSize = file.size;
                }
                let insertRet = await accountService.recharge(reqData);
                if (insertRet.success) {
                    message.success("充值申请成功");
                    onReset();
                    setRechargeDrawerVisible(false);
                } else {
                    message.error("充值失败!" + insertRet.retMsg);
                }
            }
        } catch (e) {
            console.log("数据校验失败", e);
        }
    })
    const onCancel = () => {
        setRechargeDrawerVisible(false);
    }


    return (
        <AppDrawer
            {...{
                title: "账户充值",
                visible: rechargeDrawerVisible,
                onOk,
                onCancel,
                showFooter: true
            }}
        >
            <YhForm {...formConfig} >
            </YhForm>

            <Image
                width={200}
                style={{ display: 'none' }}
                src={previewImage}
                preview={{
                    visible: previewOpen,
                    src: previewImage,
                    onVisibleChange: value => {
                        setPreviewOpen(value);
                    },
                }}
            />
        </AppDrawer>
    )
}
